export default "__VITE_ASSET__b5660ea3__"